import { TagProps } from "./types";

export default function Tag({ children }: TagProps) {
    return (
        <span style={{
            fontSize: 10, fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase",
            color: "var(--or)", background: "var(--or-dim)", border: "1px solid rgba(191,61,12,0.22)",
            borderRadius: 4, padding: "2px 7px",
        }}>{children}</span>
    );
}
